module.exports = __webpack_public_path__ + "img/special_04.c71ee652.png";